import styled from '@emotion/styled'

import type { IWrapperProps } from './types'
import { variants, sizes } from './utils'

export const Wrapper = styled.div<IWrapperProps>`
  background-color: ${({ variant }) => variants[variant]};
  padding: ${({ padding }) => sizes[padding]};
  border-radius: var(--border-radius-medium);
  box-shadow: var(--elevation-1);
`
